import Vue from "vue";
import { FILTERS } from "./Capitalize"

export const registerFilters = () => {
    Object.keys(FILTERS).forEach(key => {
        Vue.filter(key, FILTERS[key])
    })
}